// import {
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   Legend,
//   Tooltip,
// } from "recharts";

// type ChartData = {
//   name: string;
//   value: number;
// };

// interface PieChartComponentProps {
//   title: string;
//   data: ChartData[];
//   colordata: string[]; // Array of color hex codes (without `#`)
//   hireConversionRate?: number
// }

// // Custom label inside each slice
// const renderCustomizedLabel = ({
//   cx,
//   cy,
//   midAngle,
//   outerRadius,
//   value,
// }: any) => {
//   const RADIAN = Math.PI / 180;
//   const radius = outerRadius * 0.7;
//   const x = cx + radius * Math.cos(-midAngle * RADIAN);
//   const y = cy + radius * Math.sin(-midAngle * RADIAN);

//   return (
//     <text
//       x={x + 1}
//       y={y + 1}
//       fill="white"
//       textAnchor="middle"
//       dominantBaseline="central"
//       fontSize={13}
//       fontWeight={700}
//     >
//       {value}
//     </text>
//   );
// };

// // ✅ Custom Tooltip Component
// const CustomTooltip = ({
//   active,
//   payload,
//   colordata,
//   data,
// }: {
//   active?: boolean;
//   payload?: any;
//   colordata: string[];
//   data: ChartData[];
// }) => {
//   if (active && payload && payload.length) {
//     const { name, value } = payload[0].payload;
//     const index = data.findIndex(item => item.name === name);
//     const bgColor = `#${colordata[index % colordata.length]}`;

//     return (
//       <div
//         className="rounded px-3 py-1 text-sm text-white font-medium shadow"
//         style={{
//           backgroundColor: bgColor,
//           border: `1px solid ${bgColor}`,
//         }}
//       >
//         {name}: {value}
//       </div>
//     );
//   }
//   return null;
// };

// export default function PieCharts({
//   title,
//   data,
//   colordata,
//   hireConversionRate
// }: PieChartComponentProps) {
//   const isSingleData = data.length === 1;

//   return (
//     <div>
//       {/* Chart Title */}
//       <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

//       {/* Chart Container */}
//       <div className="bg-white pt-8 px-4 pb-4 rounded-xl shadow w-full">
//         {hireConversionRate >= 0 && <div className="flex justify-end">
//           <h1 className="text-sm font-semibold text-gray-600">Hire Conversion Rate: {hireConversionRate.toFixed(2)}%</h1>
//         </div>}
//         <ResponsiveContainer width="100%" height={250}>
//           <PieChart>
//             <Pie
//               data={data}
//               dataKey="value"
//               nameKey="name"
//               cx="50%"
//               cy="50%"
//               outerRadius={100}
//               labelLine={false}
//               label={renderCustomizedLabel}
//               paddingAngle={isSingleData ? 0 : 4}
//             >
//               {data.map((_, index) => (
//                 <Cell
//                   key={`cell-${index}`}
//                   fill={`#${colordata[index % colordata.length]}`}
//                 />
//               ))}
//             </Pie>

//             {/* ✅ Custom Tooltip with matching color */}
//             {/* <Tooltip
//               content={<CustomTooltip colordata={colordata} data={data} />}
//             /> */}

//             {/* Legend Below Chart */}
//             <Legend
//               layout="horizontal"
//               verticalAlign="bottom"
//               align="center"
//               iconType="circle"
//               iconSize={10}
//               wrapperStyle={{
//                 marginTop: 20,
//                 paddingTop: 10,
//                 fontSize: "13px",
//                 color: "#555",
//                 fontWeight: 500,
//                 lineHeight: "20px",
//                 textAlign: "center",
//               }}
//             />
//           </PieChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// }


import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

type ChartData = {
  name: string;
  value: number;
};

interface PieChartComponentProps {
  title: string;
  data: ChartData[];
  colordata: string[];
  hireConversionRate?: number;
}

const INNER_RADIUS = 80;
const OUTER_RADIUS = 140;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  value,
}: any) => {
  const RADIAN = Math.PI / 180;

  const radius =
    INNER_RADIUS +
    (OUTER_RADIUS - INNER_RADIUS) * 0.5;

  const x =
    cx + radius * Math.cos(-midAngle * RADIAN);

  const y =
    cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#FFFFFF"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="15"
      fontWeight="700"
    >
      {value}
    </text>
  );
};

const CustomTooltip = ({
  active,
  payload,
  colordata,
  data,
}: any) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const { name, value } = payload[0].payload;

  const index = data.findIndex(
    (item: ChartData) => item.name === name
  );

  return (
    <div
      className="rounded shadow"
      style={{
        padding: "8px 12px",
        color: "#fff",
        backgroundColor: `#${colordata[index % colordata.length]
          }`,
      }}
    >
      {name}: {value}
    </div>
  );
};

const PieCharts: React.FC<PieChartComponentProps> = ({
  title,
  data,
  colordata,
  hireConversionRate,
}) => {
  return (
    <div className="pt-8 px-4 pb-4 rounded-xl border">
      {/* Heading Style Same As PackedBubbleChart */}

      <div className="header flex items-center justify-between py-2 border-b">

        <h2 className="text-sm font-semibold text-gray-600 mb-4">
          {title}
        </h2>

        {/* Hire Conversion Rate */}
        {hireConversionRate !== undefined && (
          <div className="flex justify-end mb-3">
            <h1 className="text-sm font-semibold text-gray-600">
              Hire Conversion Rate:{" "}
              {hireConversionRate.toFixed(2)}%
            </h1>
          </div>
        )}

        {/* Blue Divider
        <div
          style={{
            height: "2px",
            background: "#3B82F6",
            marginBottom: "20px",
          }}
        /> */}
      </div>

      <div className="bg-white w-full">


        {/* Content */}
        <div
          className="flex items-center justify-between flex-wrap px-5"
        >
          {/* Chart */}
          <div
            style={{
              width: "30%",
              minWidth: "300px",
              height: "240px",
            }}
          >
            <ResponsiveContainer
              width="100%"
              height="100%"
            >
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  startAngle={180}
                  endAngle={0}
                  cx="50%"
                  cy="75%"
                  innerRadius={INNER_RADIUS}
                  outerRadius={OUTER_RADIUS}
                  paddingAngle={2}
                  labelLine={false}
                  label={renderCustomizedLabel}
                >
                  {data.map((_, index) => (
                    <Cell
                      key={index}
                      fill={`#${colordata[
                        index % colordata.length
                        ]
                        }`}
                    />
                  ))}
                </Pie>

                <Tooltip
                  content={
                    <CustomTooltip
                      data={data}
                      colordata={colordata}
                    />
                  }
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Legend */}
          <div
            style={{
              width: "20%",
              minWidth: "220px",
            }}
          >
            {data.map((item, index) => (
              <div
                key={item.name}
                className="flex items-center"
                style={{
                  marginBottom: "18px",
                }}
              >
                <span
                  className="text-sm text-gray-700"
                  style={{
                    width: "90px",
                    // textTransform: "capitalize",
                  }}
                >
                  {item.name}
                </span>

                <div
                  style={{
                    flex: 1,
                    height: "10px",
                    borderRadius: "999px",
                    backgroundColor: `#${colordata[
                      index % colordata.length
                      ]
                      }`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieCharts;